<template>
    <section class="step-item step-groups">
        <section class="step-item__title">
            <h2>Transmisja</h2>
        </section>
        <section class="step-item__body">
            <section class="step-item__body__item flex-column justify-content-center">
                <p>Zachowanie ustawień transmisji zagwarantuje ciągłość pracy systemów konferencyjncyh, czy dostęp do systemu eSesja.tv</p>
                <section class="center-item">
                    <SwitchButton label="Zachowaj ustawienie transmisji" :isPublic="$store.state.wizardNewCadence.transmissionSettings" @setIsPublic="(status) => $store.state.wizardNewCadence.transmissionSettings = status" />
                </section>
            </section>
        </section>
        <section class="step-item__footer">
            <ButtonWithIcon :icon="'additional-arrow'" :text="'Wstecz'" class="btn-step-item btn-reverse" @click="movePrev" />
            <ButtonIconAppend :icon="'additional-arrow'" class="btn-step-item" @click="moveNext">
                Dalej
            </ButtonIconAppend>
        </section>
    </section>
</template>
<script charset="utf-8">
    //import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
    //import CheckBoxButton from "../../../BasicControls/CheckBoxButton.vue";
    import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
    import ButtonIconAppend from "../../../BasicControls/ButtonIconAppend.vue";
    import SwitchButton from "../../../BasicControls/SwitchButton.vue";

    export default {
        name: "Step1SelectCurrentGroups",
        components: {
            ButtonWithIcon,
            ButtonIconAppend,
            SwitchButton,
        },
        data() {
            return {
            }
        },
        computed: {
        },
        async mounted() {
            try {
                await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 3 } });
                this.$store.commit("setWizardNewCadenceStepsDone", 2);
                this.$store.commit("setWizardNewCadenceCurrentStep", 3);
            }
            finally {
                this.$store.commit("setWizardNewCadenceBusyStatus", false);
            }
        },
        methods: {
            //async internalFetchAvailableGroups() {
            //    let response = await wizardNewCadenceService.getAvailableGroups();
            //    if (response.status === 200)
            //        this.groups = response.data;

            //    console.log(this.groups);
            //},

            async moveNext() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    this.$store.commit("setWizardNewCadenceStepsDone", 2);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 3 } });
                    this.$store.commit("setWizardNewCadenceCurrentStep", 3);
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },

            async movePrev() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 1 } });
                    this.$store.commit("setWizardNewCadenceCurrentStep", 1);
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "@/assets/scss/wizard-generic-step.scss";

    .center-item{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
</style>